import type { DetailedHTMLProps, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { type Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';

import { dialogPageTakeoverWidth, inputFieldHeight } from '../style-utils';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SearchAnchorWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & {
		shouldFillContainer?: boolean;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
	},
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div<{ shouldFillContainer?: boolean }>`
	position: relative;
	/* Prevent the input from being 200px when the icon is at the maximum icon width */
	@media screen and (min-width: ${dialogPageTakeoverWidth + 1}px) {
		${(props) => (props.shouldFillContainer ? 'width: 100%;' : 'min-width: 200px;')};
	}
	${(props) => (props.shouldFillContainer ? 'max-width: 780px;' : '')}
	width: ${inputFieldHeight.px};
	height: ${inputFieldHeight.px};
`;
